<template>
  <v-layout column>
    <v-flex>
      <v-toolbar color="#eee" class="elevation-0 secondary--text mb-4" style="background: transparent">
        <v-toolbar-title>Meios de Recebimento</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn round :color="empresas ? '': 'primary'" @click="empresas= !empresas">
          {{ empresas ? 'Mostrar meios de recebimentos clientes' :'Mostrar meios de recebimentos empresas' }}
        </v-btn>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon color="info" v-on="on" @click="dialogAutenticacao = true">
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <h4>Adicionar meio de recebimento</h4>
        </v-tooltip>
        <v-dialog
          v-model="dialogNovoPagamento"
          lazy
          :fullscreen="$vuetify.breakpoint.xs"
          width="500"
          transition="dialog-bottom-transition"
          persistent
        >
          <cad-pagamento v-if="!empresas" @fechar="dialogNovoPagamento = false"></cad-pagamento>
          <cad-recebimento-empresas v-else @fechar="dialogNovoPagamento = false"/>
        </v-dialog>
      </v-toolbar>
    </v-flex>
    <v-flex v-if="!empresas">
      <v-flex>
        <v-data-table
          hide-actions
          :loading="loading"
          :items="pagamentosExtra"
          :hide-headers="!pagamentosExtra.length"
          class="elevation-1"
        >
          <template v-slot:headers>
            <tr>
              <th></th>
              <th class="text-xs-center">Descrição</th>
              <th class="text-xs-center">Destino</th>
              <th v-for="tp in tiposPagamento" :key="tp.id" class="text-xs-center">{{tp.descricao}}</th>
              <th class="text-xs-center">Habilitar</th>
              <th></th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left">
                <v-avatar>
                  <v-icon class="green--text">credit_card</v-icon>
                </v-avatar>
              </td>
              <td class="text-xs-center">
                {{ props.item.forma_pagamento.descricao }}
              </td>
              <td class="text-xs-center">
                {{ destinos[props.item.destino] }}
              </td>
              <!--====================== ACEITAR DEBITO =========-->

              <!-- <td v-if="props.item.aceitar_debito" class="text-xs-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon color="green" class="pr-1">check_circle</v-icon>
                    <span class="body-2 font-weight-regular">Ativo</span>
                    <span v-on="on">Pagamento Secundário</span>
                  </template>
                  Somente um pagamento com débito e credito pode ficar marcado como ativo.
                </v-tooltip>
              </td>-->
              <td v-for="tp in tiposPagamento" :key="tp.id_tipo_pagamento" class="text-xs-center">
                <v-layout align-center justify-center>
                  <template v-if="props.item.forma_pagamento[tp.referencia]">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-radio
                          v-show="!props.item[tp.referencia]"
                          v-on="on"
                          @click.stop="() => ativarPagamento(props.item.id, tp.id_tipo_pagamento, 0)"
                        ></v-radio>
                        <v-layout
                          v-show="props.item[tp.referencia]"
                          justify-center
                          align-center
                        >
                        <v-icon color="green" class="pr-1" @click.stop="() => ativarPagamento(props.item.id, tp.id_tipo_pagamento, 1)">check_circle</v-icon>
                        </v-layout>
                      </template>
                      Somente um pagamento com {{tp.descricao}} pode ficar marcado como ativo.
                    </v-tooltip>
                  </template>
                  <template v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-avatar v-on="on" >
                          <v-icon class="red--text">block</v-icon>
                        </v-avatar>
                      </template>
                      Esta forma de pagamento não permite débito.
                    </v-tooltip>
                  </template>
                </v-layout>
              </td>
             <td style="width: 10px">
              <v-tooltip lazy bottom>
                  <template v-slot:activator="{ on }">
                    <v-switch v-on="on" v-model="props.item.forma_pagamento.disponivel" readonly @click.stop="() => habilitarPagamento(props.item.forma_pagamento.id)">
                    </v-switch>
                  </template>
                  Mudar dispobilidade
                </v-tooltip>
              </td>
              <td class="text-xs-right">
                <v-tooltip lazy bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      @click="
                        meioSelecionado = props.item,
                        editar_destino = true
                      "
                    >
                      <v-icon color="primary">edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar Destino</span>
                </v-tooltip>
                <v-tooltip lazy bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click="apagarPagamento(props.item)">
                      <v-icon color="error">delete</v-icon>
                    </v-btn>
                  </template>
                  Apagar
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-toolbar-title>Meios recebimentos secundários</v-toolbar-title>
      <v-flex>
        <v-data-table
          hide-actions
          :loading="loading"
          :items="pagamentosSecundarios"
          :hide-headers="!pagamentosSecundarios.length"
          class="elevation-1"
        >
          <template v-slot:headers>
            <tr>
              <th></th>
              <th class="text-xs-center">Descrição</th>
              <th class="text-xs-center">Destino</th>
              <th v-for="tp in tiposPagamento" :key="tp.id" class="text-xs-center">{{tp.descricao}}</th>
              <th class="text-xs-center">Habilitar</th>
              <th></th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left">
                <v-avatar>
                  <v-icon class="green--text">credit_card</v-icon>
                </v-avatar>
              </td>
              <td class="text-xs-center">
                {{ props.item.forma_pagamento.descricao }}
              </td>
              <td class="text-xs-center">
                {{ destinos[props.item.destino] }}
              </td>
              <td v-for="tp in tiposPagamento" :key="tp.id_tipo_pagamento" class="text-xs-center">
                <v-layout align-center justify-center>
                  <template v-if="props.item.forma_pagamento[tp.referencia]">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-radio
                          v-show="!props.item[tp.referencia]"
                          v-on="on"
                          @click.stop="() => ativarPagamento(props.item.id, tp.id_tipo_pagamento, 0)"
                        ></v-radio>
                        <v-layout
                          v-show="props.item[tp.referencia]"
                          justify-center
                          align-center
                        >
                        <v-icon color="green" class="pr-1" @click.stop="() => ativarPagamento(props.item.id, tp.id_tipo_pagamento, 1)">check_circle</v-icon>
                        </v-layout>
                      </template>
                      Somente um pagamento com {{tp.descricao}} pode ficar marcado como ativo.
                    </v-tooltip>
                  </template>
                  <template v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-avatar v-on="on" >
                          <v-icon class="red--text">block</v-icon>
                        </v-avatar>
                      </template>
                      Esta forma de pagamento não ser vinculada.
                    </v-tooltip>
                  </template>
                </v-layout>
              </td>
             <td style="width: 10px">
              <v-tooltip lazy bottom>
                  <template v-slot:activator="{ on }">
                    <v-switch v-on="on" v-model="props.item.forma_pagamento.disponivel" readonly @click.stop="() => habilitarPagamento(props.item.forma_pagamento.id)">
                    </v-switch>
                  </template>
                  Mudar disponibilidade
                </v-tooltip>
              </td>
              <td class="text-xs-right">
                <v-tooltip lazy bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      @click="
                        meioSelecionado = props.item,
                        editar_destino = true
                      "
                    >
                      <v-icon color="primary">edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar Destino</span>
                </v-tooltip>
                <v-tooltip lazy bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click="apagarPagamento(props.item)">
                      <v-icon color="error">delete</v-icon>
                    </v-btn>
                  </template>
                  Apagar
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <template v-if="posto && posto.recebe_pospago">
        <select-metodos-pospago></select-metodos-pospago>
      </template>
    </v-flex>
    <v-flex v-else>
      <template v-if="posto">
        <select-metodos-empresas></select-metodos-empresas>
      </template>
    </v-flex>
    <v-dialog
      v-model="dialogAutenticacao"
      v-if="dialogAutenticacao"
      width="35em"
    >
      <autenticacao-por-sms
        @fechar="dialogAutenticacao = false"
        @callDialog="dialogNovoPagamento = true"
      />
    </v-dialog>
    <v-dialog
      v-model="editar_destino"
      v-if="editar_destino"
      width="500"
    >
      <editar-meio-recebimento
        @fechar="
          editar_destino = false,
          meioSelecionado = undefined
        "
        :meioSelecionado="meioSelecionado"
        @showSnackbar="showSnackbar"
      />
    </v-dialog>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.active = false"
      >
        Fechar
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import AutenticacaoPorSms from '@/components/dialogs/SmartLock'
import EditarMeioRecebimento from '@/components/dialogs/EditarMeioRecebimento'
const CadPagamento = () => import('../components/cadastros/CadPagamentoExtra')
const SelectMetodosPospago = () => import('../components/cadastros/SelectMetodosPospago')
const SelectMetodosEmpresas = () => import('../components/cadastros/SelectMetodosEmpresas')
const CadRecebimentoEmpresas = () => import('../components/cadastros/CadRecebimentoEmpresas')

export default {
  components: {
    CadPagamento,
    SelectMetodosPospago,
    SelectMetodosEmpresas,
    CadRecebimentoEmpresas,
    AutenticacaoPorSms,
    EditarMeioRecebimento
  },
  data () {
    return {
      empresas: false,
      dialogNovoPagamento: false,
      dialogAutenticacao: false,
      editar_destino: false,
      meioSelecionado: undefined,
      destinos: {
        1: 'Clientes',
        2: 'Postos',
        3: 'Empresas',
        4: 'Todos'
      },
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      }
    }
  },
  mounted () {
    if (this.posto) {
      this.$store.dispatch('carregarPagamentosExtra', this.pagination)
      this.$store.dispatch('carregarPagamentosSecundarios', this.pagination)
    }
  },
  methods: {
    showSnackbar (text, color) {
      this.snackbar.color = color
      this.snackbar.text = text
      this.snackbar.active = true
    },
    apagarPagamento (pagamento) {
      this.$store
        .dispatch('apagarPagamentoExtra', {
          pagamento: pagamento.id,
          model: {
            posto: this.posto.cnpj
          }
        })
        .then(() => {
          this.$store.dispatch('carregarPagamentosExtra', this.pagination)
          this.$store.dispatch('carregarPagamentosSecundarios', this.pagination)
        })
    },
    ativarPagamento (idMeioPagamento, idTipoPagamento, deletar) {
      this.$store.dispatch('ativarPagamentoExtra', {
        meio_pagamento: idMeioPagamento,
        tipo_pagamento: idTipoPagamento,
        deletar
      }).then(() => {
        this.$store.dispatch('carregarPagamentosExtra', this.pagination)
        this.$store.dispatch('carregarPagamentosSecundarios', this.pagination)
      })
    },
    habilitarPagamento (idTipoPagamento) {
      this.$store.dispatch('habilitarPagamentoExtra', {
        meio_pagamento: idTipoPagamento
      }).then(() => {
        this.$store.dispatch('carregarPagamentosExtra', this.pagination)
        this.$store.dispatch('carregarPagamentosSecundarios', this.pagination)
      })
    }
  },
  watch: {
    posto (val) {
      if (val) {
        this.$store.dispatch('carregarPagamentosExtra', this.pagination)
        this.$store.dispatch('carregarPagamentosSecundarios', this.pagination)
      }
    }
  },
  computed: {
    tiposPagamento () {
      return this.$store.getters.tiposPagamento
    },
    posto () {
      return this.$store.getters.posto
    },
    loading () {
      return this.$store.getters.loading
    },
    pagamentosExtra () {
      return this.$store.getters.pagamentosExtra.map(
        (pagExtra) => {
          let pag = {
            id: pagExtra.id,
            destino: pagExtra.destino
          }
          this.tiposPagamento.forEach(tp => {
            if (!pagExtra.tipos_pagamento || !pagExtra.tipos_pagamento.find(t => t.referencia === tp.referencia)) {
              pag[`${tp.referencia}`] = false
            } else {
              pag[`${tp.referencia}`] = true
            }
          })
          pag.forma_pagamento = {
            id: pagExtra.forma_pagamento.id_forma_pagamento,
            credito: pagExtra.forma_pagamento.aceita_credito,
            debito: pagExtra.forma_pagamento.aceita_debito,
            pix: pagExtra.forma_pagamento.aceita_pix,
            boleto: pagExtra.forma_pagamento.aceita_boleto,
            cashback: pagExtra.forma_pagamento.aceita_cashback,
            descricao: pagExtra.forma_pagamento.descricao,
            disponivel: pagExtra.forma_pagamento.disponivel
          }
          return pag
        }
      )
    },
    pagamentosSecundarios () {
      return this.$store.getters.pagamentosSecundarios.map(
        (pagExtra) => {
          let pag = {
            id: pagExtra.id,
            destino: pagExtra.destino
          }
          this.tiposPagamento.forEach(tp => {
            if (!pagExtra.tipos_pagamento || !pagExtra.tipos_pagamento.find(t => t.referencia === tp.referencia)) {
              pag[`${tp.referencia}`] = false
            } else {
              pag[`${tp.referencia}`] = true
            }
          })
          pag.forma_pagamento = {
            id: pagExtra.forma_pagamento.id_forma_pagamento,
            credito: pagExtra.forma_pagamento.aceita_credito,
            debito: pagExtra.forma_pagamento.aceita_debito,
            pix: pagExtra.forma_pagamento.aceita_pix,
            boleto: pagExtra.forma_pagamento.aceita_boleto,
            cashback: pagExtra.forma_pagamento.aceita_cashback,
            descricao: pagExtra.forma_pagamento.descricao,
            disponivel: pagExtra.forma_pagamento.disponivel,
            pagamento_secundario: pagExtra.forma_pagamento.pagamento_secundario
          }
          return pag
        }
      )
    },
    headers () {
      return this.$store.getters.headers
    }
  }
}
</script>
